<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" style="max-width:1000px;">

        <!-- Back -->
        <v-btn text color="#1A3A5C" class="mt-4 mb-2 px-0" @click="$router.push({ name: '/admin_fs_users' })">
          <v-icon left small>mdi-chevron-left</v-icon>Back to First Steps Users
        </v-btn>

        <!-- Loading -->
        <div v-if="loading" class="text-center py-12">
          <v-progress-circular indeterminate color="#1A3A5C" size="48" />
        </div>

        <template v-else-if="user">

          <!-- Header -->
          <v-card elevation="1" class="rounded-xl pa-6 mb-5">
            <div class="d-flex align-center justify-space-between flex-wrap" style="gap:12px;">
              <div>
                <h2 style="font-size:24px; font-weight:700; color:#1A3A5C;">{{ user.name }}</h2>
                <div class="body-2 grey--text">{{ user.email }}</div>
              </div>
              <v-chip large :color="statusColor(user.stripe_status)" dark style="font-size:14px; font-weight:700;">
                {{ statusLabel(user.stripe_status) }}
              </v-chip>
            </div>
          </v-card>

          <!-- Subscription details -->
          <v-card elevation="1" class="rounded-xl pa-6 mb-5">
            <h3 class="section-heading mb-4">Subscription</h3>
            <v-row>
              <v-col cols="6" sm="4" md="3" v-for="field in subscriptionFields" :key="field.label">
                <div class="field-label">{{ field.label }}</div>
                <div class="field-value">{{ field.value || '—' }}</div>
              </v-col>
            </v-row>
          </v-card>

          <!-- Section completion -->
          <v-card elevation="1" class="rounded-xl pa-6 mb-5">
            <h3 class="section-heading mb-1">Dashboard sections</h3>
            <p class="caption grey--text mb-4">
              Last updated: {{ lastUpdated || 'No data saved yet' }}
            </p>
            <v-row dense>
              <v-col cols="12" sm="6" md="4" v-for="s in sections" :key="s.key">
                <div class="d-flex align-center py-2" style="border-bottom:1px solid #f0f0f0;">
                  <v-icon small :color="s.filled ? 'success' : 'grey lighten-1'" class="mr-2">
                    {{ s.filled ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                  </v-icon>
                  <span :class="s.filled ? 'font-weight-medium' : 'grey--text'">{{ s.label }}</span>
                  <v-spacer />
                  <v-chip x-small :color="s.filled ? 'success' : 'grey lighten-2'" :dark="s.filled">
                    {{ s.filled ? 'Filled' : 'Empty' }}
                  </v-chip>
                </div>
              </v-col>
            </v-row>
            <div class="mt-3 caption grey--text">
              {{ filledCount }} of {{ sections.length }} sections have data
            </div>
          </v-card>

        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'FSUserDetail',
  data: () => ({
    loading: true,
    user: null,
    sections: [],
    lastUpdated: null,
  }),

  computed: {
    subscriptionFields () {
      if (!this.user) return []
      return [
        { label: 'Signed up',          value: this.user.signed_up },
        { label: 'Email verified',      value: this.user.email_verified_at },
        { label: 'Stripe status',       value: this.statusLabel(this.user.stripe_status) },
        { label: 'Trial ends',          value: this.user.trial_ends_at
            ? `${this.user.trial_ends_at}${this.user.stripe_status === 'trialing' ? ` (${this.user.trial_days_left}d left)` : ''}`
            : null },
        { label: 'Subscription ends',   value: this.user.subscription_ends_at },
        { label: 'Grace period ends',   value: this.user.grace_ends_at },
        { label: 'Stripe customer ID',  value: this.user.stripe_customer_id },
        { label: 'Stripe sub ID',       value: this.user.stripe_subscription_id },
      ]
    },

    filledCount () {
      return this.sections.filter(s => s.filled).length
    },
  },

  async mounted () {
    const id = this.$route.params.id
    const res = await this.$axios.get(`/auth/admin/fs_users/${id}`)
    if (res && res.data && res.data.response) {
      this.user        = res.data.data.user
      this.sections    = res.data.data.sections
      this.lastUpdated = res.data.data.last_updated
    }
    this.loading = false
  },

  methods: {
    statusColor (s) {
      const map = { trialing: '#2E75B6', active: 'success', lifetime: 'teal', past_due: 'orange darken-1', canceled: 'error' }
      return map[s] || 'grey'
    },
    statusLabel (s) {
      const map = { trialing: 'Free trial', active: 'Active subscriber', lifetime: 'Lifetime', past_due: 'Past due', canceled: 'Canceled', unpaid: 'Unpaid' }
      return map[s] || (s || 'No subscription')
    },
  },
}
</script>

<style scoped>
.section-heading { font-size: 17px; font-weight: 700; color: #1A3A5C; }
.field-label { font-size: 11px; color: rgba(0,0,0,0.45); text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 2px; }
.field-value { font-size: 15px; color: #1A3A5C; font-weight: 600; }
</style>
